import { createRoute, lazyRouteComponent } from "@tanstack/react-router";

import { portalRoute } from "../_portal.js";

export const portalProgrammesRoute = createRoute({
  getParentRoute: () => portalRoute,
  path: "/portal/programmes",
  component: lazyRouteComponent(() => import("./programmes.page.js"), "PortalProgrammesPage"),
});

export const portalProgrammeDetailRoute = createRoute({
  getParentRoute: () => portalRoute,
  path: "/portal/programmes/$subjectId",
  component: lazyRouteComponent(
    () => import("./programmes.$subjectId.page.js"),
    "PortalProgrammeDetailPage",
  ),
});
